<template>
  <div>
      <user-profile-detail-transation-component/>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>